module.exports = {
  ssm_service: "https://mobile.sportsites.com"
}